/**
 * CardcomManagement ("ניהול Cardcom") — route /cardcomConfig.
 * Webhook configurations: what happens in the CRM when someone pays through a Cardcom page
 * (matched by Custom19) or buys a specific item (matched by SKU). The list and editor live in
 * components/CardcomConfigManager.js. (There used to be a single tab here — add Tabs back if
 * logs / stats views are ever added.)
 */
import React from 'react';
import { Page, PageHeader } from '../../ui';
import CardcomConfigManager from './components/CardcomConfigManager';

const CardcomManagement = () => (
  <Page>
    <PageHeader title="ניהול Cardcom" subtitle="מה קורה ב-CRM כשמישהו משלם דרך Cardcom" />
    <CardcomConfigManager />
  </Page>
);

export default CardcomManagement;
